import {
  ChartDataset,
  ChartStyle
} from "state/ui/editor/elements/ChartElement";
import {
  buildPieSlices,
  describeArc,
  formatTickLabel,
  legendGutterFor
} from "../chartScales";

interface Props {
  dataset: ChartDataset;
  style: ChartStyle;
  width: number;
  height: number;
  innerRadiusRatio?: number;
}

const PieChart = ({
  dataset,
  style,
  width,
  height,
  innerRadiusRatio = 0
}: Props) => {
  const padding = 12;
  const legendGutter = style.showLegend
    ? legendGutterFor(style.fontSize) + padding
    : padding;

  const availableWidth = Math.max(width - padding * 2, 1);
  const availableHeight = Math.max(height - legendGutter - padding, 1);
  const radius = Math.max(Math.min(availableWidth, availableHeight) / 2, 1);
  const innerRadius = radius * innerRadiusRatio;

  const cx = width / 2;
  const cy = padding + availableHeight / 2;

  const firstRow = dataset.rows[0];
  const values = firstRow ? firstRow.values : [];
  const slices = buildPieSlices(values, dataset.headers, style.seriesColors);

  return (
    <g>
      {slices.map((slice, index) => (
        <g key={`slice-${index}`}>
          <path
            d={describeArc(
              cx,
              cy,
              radius,
              slice.startAngle,
              slice.endAngle,
              innerRadius
            )}
            fill={slice.color}
          />
          {style.showDataLabels && (
            <text
              x={
                cx +
                ((radius + innerRadius) / 2) *
                  Math.cos((slice.startAngle + slice.endAngle) / 2)
              }
              y={
                cy +
                ((radius + innerRadius) / 2) *
                  Math.sin((slice.startAngle + slice.endAngle) / 2)
              }
              fontSize={style.fontSize}
              fill="#ffffff"
              fontFamily={style.fontFamily}
              textAnchor="middle"
              dominantBaseline="middle"
            >
              {formatTickLabel(slice.value)}
            </text>
          )}
        </g>
      ))}
    </g>
  );
};

export default PieChart;
